import { isPlainObject } from '@reduxjs/toolkit'
import { SerializeQueryArgs } from '../../../types/rtkInternals'

// For some reason, importing from '@reduxjs/toolkit/dist/query/defaultSerializeQueryArgs'
// crashes dev server, so I have to copy-paste code like this :/
export const defaultSerializeQueryArgs: SerializeQueryArgs<any> = ({ endpointName, queryArgs }) => {
  // Sort the object keys before stringifying, to prevent useQuery({ a: 1, b: 2 }) having a different cache key than useQuery({ b: 2, a: 1 })
  return `${endpointName}(${JSON.stringify(queryArgs, (key, value) =>
    isPlainObject(value)
      ? Object.keys(value)
          .sort()
          .reduce<any>((acc, key) => {
            acc[key] = (value as any)[key]
            return acc
          }, {})
      : value
  )})`
}
